import {Component, effect, inject, input, model, signal} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Dialog} from 'primeng/dialog';
import {Button} from 'primeng/button';
import {InputText} from 'primeng/inputtext';
import {BasicTaDetails} from '../../../api';
import {TemplateDatasource} from '../../../datasources/template.datasource';

/** Asks for a title, then saves the TA as a template (or creates an empty one when no TA). Server errors show inline. */
@Component({
  selector: 'create-template-from-ta-dialog',
  imports: [
    FormsModule,
    Dialog,
    Button,
    InputText,
  ],
  templateUrl: './create-template-from-ta-dialog.html',
})
export class CreateTemplateFromTaDialog {
  private templateDatasource = inject(TemplateDatasource);

  ta = input<Pick<BasicTaDetails, 'id' | 'taNumber'> | undefined>();
  visible = model<boolean>(false);
  name = signal('');
  error = signal<string | null>(null);
  saving = signal(false);

  constructor() {
    // A blank form each time it opens.
    effect(() => {
      if (this.visible()) {
        this.name.set('');
        this.error.set(null);
        this.saving.set(false);
      }
    });
  }

  setName(value: string): void {
    this.name.set(value);
    this.error.set(null);
  }

  async create(): Promise<void> {
    const id = this.ta()?.id;
    const name = this.name().trim();
    if (!name || this.saving()) return;
    this.saving.set(true);
    const error = id
      ? await this.templateDatasource.createTemplateFromTa(id, name)
      : await this.templateDatasource.createTemplate(name);
    this.saving.set(false);
    if (error === null) {
      this.visible.set(false);
    } else {
      this.error.set(error);
    }
  }
}
